/** SHA、域名、写域路径单行截断保留尾部。摘要不许走这里。 */
export function truncateTail(value: string, keep = 12): string {
  if (value.length <= keep) return value
  return `…${value.slice(-keep)}`
}

const TAIL_KINDS = new Set(['sha', 'commit', 'domain', 'path', 'host', 'url'])

export function isTailField(kind: string): boolean {
  const key = kind.toLowerCase()
  return TAIL_KINDS.has(key) || key.includes('sha') || key.includes('path') || key.includes('domain')
}
